//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'IPS',
  data() {
    return {
      form: {
        item1: '0',
        item2: '0',
        item3: '0',
        item4: '0',
        item5: '0',
        item6: '0',
        item7: '0',
      },
      hasScore: false,
      disabled: false,
      descTxt: '',
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5 + form.item6 + form.item7
      self.hasScore = true
      if (result == 0) {
        self.descTxt = `5年无进展生存率(FFP)88%
        5年总体生存率(OS)98 % `
      } else if (result == 1) {
        self.descTxt = `5年无进展生存率(FFP)84%
        5年总体生存率(OS)97 % `
      } else if (result == 2) {
        self.descTxt = `5年无进展生存率(FFP)80%
        5年总体生存率(OS)91 % `
      } else if (result == 3) {
        self.descTxt = `5年无进展生存率(FFP)74%
        5年总体生存率(OS)88 % `
      } else if (result == 4) {
        self.descTxt = `5年无进展生存率(FFP)67%
        5年总体生存率(OS)85 % `
      } else {
        self.descTxt = `5年无进展生存率(FFP)62%
        5年总体生存率(OS)67 % `
      }
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/IPS.vue